import { render, staticRenderFns } from "./rtnLimDet.vue?vue&type=template&id=927e1730&"
import script from "./rtnLimDet.vue?vue&type=script&lang=js&"
export * from "./rtnLimDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports